import React from "react";

interface SettingsGridProps {
  menuGroups: server.dto.OptionMenuGroup[]
}

const SettingsGrid = ({ menuGroups }: SettingsGridProps) => {
  return <div className="s1_panel settings-grid-wrapper">
    {menuGroups.map(group => (
      <div key={group.label}>
        <h2 className="info-text-semibold">{group.label}</h2>
        <div className="settings-grid-group-items">
          {group.items.map(item => (
            <div className="settings-grid-item-wrapper" key={item.url}>
              <a href={item.url} className="settings-grid-item-link">{item.label}</a>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>;
}

export default SettingsGrid;
